const ReservationStatusEnum = {
    PENDING: 1,
    WAITING_LIST: 2,
    CONFIRMED: 3,
    WAITING_FOR_PREPAYMENT: 4,
    CANCELLED: 5,
    DELETED: 6
  };

  export default ReservationStatusEnum;